module.exports = __webpack_public_path__ + "static/media/dice-four.328e937c.svg";